import React from 'react'
import PropTypes from 'prop-types'

import Title from '@components/text/title'
import SubText from '../subText'

import 'material-icons/iconfont/outlined.css'

import { Container, CloseIcon, TopTitle } from './styles'

const FormTitle = ({
  title, onClickGoBack, style, topTitle, subtitle,
}) => {
  const backHeader = () => onClickGoBack && <CloseIcon className="material-icons-outlined" onClick={onClickGoBack}>close</CloseIcon>

  return (
    <Container style={style}>
      {backHeader()}
      {topTitle && <TopTitle>{topTitle}</TopTitle>}
      <Title>{title}</Title>
      <SubText>{subtitle}</SubText>
    </Container>
  )
}

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
  onClickGoBack: PropTypes.func,
  style: PropTypes.shape({}),
  topTitle: PropTypes.string,
  subtitle: PropTypes.string,
}

FormTitle.defaultProps = {
  onClickGoBack: null,
  style: null,
  topTitle: null,
  subtitle: null,
}

export default FormTitle
